import { jsx } from 'react/jsx-runtime';
import { ErrorBoundary } from 'react-error-boundary';
import { logError } from '../../services/error-service.js';

const DefaultFallbackRender = () => {
    return null;
};
const SentryErrorBoundary = ({ children, fallbackRender = DefaultFallbackRender, }) => {
    return (jsx(ErrorBoundary, { fallbackRender: fallbackRender, onError: (error) => {
            logError({ error });
        }, children: children }));
};

export { SentryErrorBoundary };
//# sourceMappingURL=SentryErrorBoundary.js.map
